module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p9-0781429e1693fd85481a5811b1e6a412.png";